import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { API_URL, scroll, isFieldError } from "../helpers";
import "./styles.css";
import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Select from "../components/Select";
import Input from "../components/Input";
//import Checkbox from "../components/Checkbox";
import Textarea from "../components/Textarea";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const Rsvp = () => {
  const [errors, setErrors] = useState([]);
  const [names, setNames] = useState({
    charities: [],
  });
  const [msg, setMsg] = useState({});
  const [alert, setAlert] = useState({
    type: "working",
    text: "",
  });

  const query = new URLSearchParams(useLocation().search);
  const type = query.get("type") || "charity";

  useEffect(() => {
    scroll();
    init();
  }, []);

  const init = async (id) => {
    const url = new URL(`${API_URL}/rsvpInit`);

    try {
      const response = await fetch(url, {
        method: "GET",
        cache: "no-store",
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        setAlert({});
        setNames({ charities: json.data });
      } else {
        setAlert({ type: "error", text: json.text });
      }
    } catch (error) {
      setAlert({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  const handleUpdate = (name, value) => {
    setNames((names) => ({ ...names, [name]: value ? value : "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setMsg({
      type: "working",
      text: "",
    });

    const url = new URL(`${API_URL}/rsvp`);
    let data = new FormData();
    Object.entries(names).forEach(([key, value]) => {
      if (key === "charities") {
      } else {
        data.append(key, value);
      }
    });
    data.append("type", type);

    try {
      const response = await fetch(url, {
        method: "POST",
        body: data,
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        setAlert({
          type: "success",
          text: json.text,
        });
      } else {
        setErrors(json.fields);
        setMsg({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setMsg({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  return (
    <div id="full-column">
      <Hdg />

      <div className="invite-container">
        <p>
          Valero Texas Open’s{" "}
          <b>
            Champions <i>fore</i> Charity
          </b>{" "}
          is proud to host the Celebration of Champions luncheon. Join us as we
          honor and celebrate the hard work and accomplishments of the
          participating charities and schools in the 2020-2021 fundraising
          campaign. Champions fore Charity Ambassadors <b>Randy Carroll</b>,
          KJ97 Morning Show Host, <b>David Chancellor</b>, WOAI TV News Anchor,
          and <b>Kimberly Crawford</b>, co-host of “Daytime with Kimberly &
          Esteban” on KABB, will be in attendance to help us with our check
          presentations!
        </p>
        <img
          src="https://vto-qnewmedia2.netdna-ssl.com/assets/img/celebrationofchampions-right-1.png?1032"
          alt="Invitation"
        />
      </div>

      <table className="approved rsvp">
        <thead>
          <tr>
            <th>Date</th>
            <th>Schedule</th>
            <th>Location</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td className="center">
              Thursday, June 24
              <br />
              11:30 am – 1:00 pm
            </td>
            <td className="center">11:30 am – Lunch; 12:15 pm – Remarks</td>
            <td className="center">
              The Rustic at The Rim
              <br />
              17619 La Cantera Pkwy Ste 204, San Antonio, TX 78257
            </td>
          </tr>
        </tbody>
      </table>

      {alert.type ? (
        <Alert data={alert} />
      ) : (
        <form
          method="post"
          action="/"
          onSubmit={(e) => handleSubmit(e)}
          className="well"
        >
          <h3 style={{ marginTop: "0" }}>Celebration of Champions RSVP Form</h3>

          <p>
            {type === "charity"
              ? `Use this form to RSVP up to 2 charity representatives at this year’s event. Please RSVP by Friday, June 18th.`
              : `Use this form to RSVP yourself and an optional guest for this year’s
          event. Please RSVP by Friday, June 18th.`}
          </p>

          {type === "charity" && (
            <div className="form-group">
              <Select
                name="charity"
                label="Select Charity"
                reqd={true}
                value={""}
                options={[{ id: "", name: "--" }].concat(
                  names.charities.map((item) => {
                    return {
                      id: item.name,
                      name: item.name,
                    };
                  })
                )}
                update={handleUpdate}
                error={isFieldError(errors, "charity")}
              />

              <Select
                name="attending"
                label="Are you attending the event?"
                reqd={true}
                value={""}
                options={[
                  { id: "", name: "--" },
                  { id: "yes", name: "Yes, I will be attending." },
                  { id: "mail", name: "No, please mail my check." },
                  {
                    id: "pickup",
                    name: "No, I will arrange to pick up my check.",
                  },
                ]}
                update={handleUpdate}
                error={isFieldError(errors, "attending")}
              />
            </div>
          )}

          <div
            className="form-group"
            style={{ marginTop: "15px", marginBottom: "5px" }}
          >
            <label className="control-label" style={{ paddingBottom: "0" }}>
              {type === "charity" ? `Representative #1:` : `Guest #1:`}
            </label>
          </div>

          <div className="form-group">
            <Input
              name="fname1"
              label="First Name"
              reqd={true}
              value={""}
              update={handleUpdate}
              errors={errors}
              autocomplete="given-name"
            />

            <Input
              name="lname1"
              label="Last Name"
              reqd={true}
              value={""}
              update={handleUpdate}
              errors={errors}
              autocomplete="family-name"
            />
          </div>

          <div className="form-group">
            <Input
              name="email1"
              label="Email"
              reqd={true}
              value={""}
              update={handleUpdate}
              errors={errors}
            />

            <Input
              name="phone1"
              label="Cell Phone"
              reqd={true}
              value={""}
              update={handleUpdate}
              errors={errors}
              autocomplete="tel"
            />
          </div>

          {type === "guest" && (
            <div className="form-group">
              <Input
                name="company1"
                label="Company"
                reqd={false}
                value={""}
                update={handleUpdate}
                errors={errors}
              />

              <div className="empty" />
            </div>
          )}

          {(!names.attending || names.attending === "yes") && (
            <div
              className="form-group"
              style={{ marginTop: "15px", marginBottom: "5px" }}
            >
              <label className="control-label" style={{ paddingBottom: "0" }}>
                {type === "charity" ? `Representative #2:` : `Guest #2:`}
              </label>
            </div>
          )}

          {(!names.attending || names.attending === "yes") && (
            <div className="form-group">
              <Input
                name="fname2"
                label="First Name"
                reqd={false}
                value={""}
                update={handleUpdate}
                errors={errors}
                autocomplete="off"
              />

              <Input
                name="lname2"
                label="Last Name"
                reqd={false}
                value={""}
                update={handleUpdate}
                errors={errors}
                autocomplete="off"
              />
            </div>
          )}

          {(!names.attending || names.attending === "yes") && (
            <div className="form-group">
              <Input
                name="email2"
                label="Email"
                reqd={false}
                value={""}
                update={handleUpdate}
                errors={errors}
                autocomplete="off"
              />

              <Input
                name="phone2"
                label="Cell Phone"
                reqd={false}
                value={""}
                update={handleUpdate}
                errors={errors}
                autocomplete="off"
              />
            </div>
          )}

          {type === "guest" && (
            <div className="form-group">
              <Input
                name="company2"
                label="Company"
                reqd={false}
                value={""}
                update={handleUpdate}
                errors={errors}
              />

              <div className="empty" />
            </div>
          )}

          <div className="form-group">
            <Textarea
              name="comments"
              label="Notes (i.e. Dietary Restrictions)"
              reqd={false}
              value={names.mission || ""}
              update={handleUpdate}
              errors={errors}
            />
            <div />
          </div>

          <div className="msg-submit">
            {msg.type && <Msg data={msg} />}

            <div
              className={
                msg.type === "working" || msg.type === "success"
                  ? "hidden"
                  : "submit-container"
              }
            >
              <Submit path="" left="" submit="Submit RSVP" />
            </div>
          </div>
        </form>
      )}
    </div>
  );
};

export default Rsvp;
